import { CookieService } from 'ngx-cookie-service';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, Router, TitleStrategy } from '@angular/router';import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from '@itb-monorepo/globalization';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { APP_TOKEN, AppsEnum, AUTH_SCOPE_TOKEN } from '@itb-monorepo/enums';
import { ErrorInterceptor } from '@itb-monorepo/services';
import { appRoutes } from './app.routes';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { AppTitleStrategy } from './app-title.strategy';
import * as Sentry from '@sentry/angular';

export function jwtOptionsFactory(cookieService: CookieService) {
  return {
    tokenGetter: () => {
      return cookieService.get('access-token');
    },
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideEnvironmentNgxMask(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient): MultiTranslateHttpLoader => {
            return new MultiTranslateHttpLoader(http, {
              resources: [{ prefix: './assets/i18n/trader/', suffix: '.json' }],
            });
          },
          deps: [HttpClient],
        },
      })
    ),
    importProvidersFrom(
      JwtModule.forRoot({
        jwtOptionsProvider: {
          provide: JWT_OPTIONS,
          useFactory: jwtOptionsFactory,
          deps: [CookieService],
        },
      })
    ),
    {
      provide: AUTH_SCOPE_TOKEN,
      useValue: 'users'
    },
    { provide: APP_TOKEN, useValue: AppsEnum.TRADER },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
